import React, { useEffect, useState } from 'react';
import { getRelationships } from '../services/api';
import { useNavigate } from 'react-router-dom';

export default function ERDViewer() {
    const [relationships, setRelationships] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        loadRelationships();
    }, []);

    const loadRelationships = async () => {
        try {
            const res = await getRelationships();
            setRelationships(res.data);
            setError(null);
        } catch (err) {
            console.error('Failed to load relationships:', err);
            setError('Failed to load relationships');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="animate-pulse">Loading relationships...</div>;
    if (error) return <div className="text-red-500">{error}</div>;

    return (
        <div className="px-4 py-5 sm:p-6">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Entity Relationships
                </h3>
                <button
                    onClick={() => navigate('/relationships')}
                    className="text-sm text-blue-600 hover:text-blue-800"
                >
                    View All →
                </button>
            </div>
            {relationships && (
                <div>
                    <div className="bg-purple-50 rounded-lg p-4 mb-4">
                        <p className="text-2xl font-bold text-purple-900">
                            {relationships.total_relationships || relationships.total || 0}
                        </p>
                        <p className="text-sm text-purple-700">Foreign Key Relationships</p>
                    </div>
                    
                    {relationships.relationships && relationships.relationships.length > 0 ? (
                        <>
                            <h4 className="text-sm font-medium text-gray-700 mb-2">
                                Sample Relationships:
                            </h4>
                            <div className="space-y-1 max-h-48 overflow-y-auto">
                                {relationships.relationships.slice(0, 10).map((rel, idx) => (
                                    <div key={idx} className="text-xs bg-gray-50 rounded p-2">
                                        <code className="text-blue-600">{rel.from_table}</code>
                                        <span className="text-gray-500 mx-1">→</span>
                                        <code className="text-green-600">{rel.to_table}</code>
                                        <span className="text-gray-400 ml-2">
                                            ({rel.from_column} → {rel.to_column})
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <p className="text-sm text-gray-500">No relationships found</p>
                    )}
                    
                    {relationships.message && (
                        <p className="text-xs text-gray-500 mt-2">{relationships.message}</p>
                    )}
                </div>
            )}
        </div>
    );
}